export enum Route {
    MailSenders = "/mail-senders",
}